const defaultSettings = {
  name: "Dialogflow",
  icon: "question_answer",
  showLabel: true,
  size: {
    width: 180,
    height: 50
  },
  resizable: false,
  draggable: true,
  has: {
    in: true,
    out: true,
    settings: true
  },
  inColor: "#ef6c00",
  outColor: "#ef6c00",
  layout: "horizontal",
  components: [/Chatbot_.*/],
  openPropertyEditorByClick: true,
  settings: {
    locked: false,
    order: 0
  }
};

export default defaultSettings;
